import React from 'react'
import Header from '../../components/Header'
import MessageParserList from './MessageParserList'

const MessageParser = () => {
    return (
        <div>
            <Header />
            <MessageParserList />
        </div>
    )
}

export default MessageParser